const checkEmptyParams = <T extends { [key: string]: any }>(params: T): T => {
  const propNames = Object.getOwnPropertyNames(params);
  for (let i = 0; i < propNames.length; i++) {
    const propName = propNames[i];
    if (
      params[propName]?.length === 0 ||
      params[propName] === null ||
      params[propName] === undefined
    ) {
      delete params[propName];
    }
  }

  return params;
};

export { checkEmptyParams };
